import Layout from "../components/layout/Layout";
import AuthorizationScreen from "../components/page/AuthorizationScreen";

const AuthorizationScreenPage = () => {

  return (
    <Layout>
        <AuthorizationScreen />
    </Layout>
  );
};
export default AuthorizationScreenPage;
